import { defineStore } from 'pinia'
import { ref, computed } from 'vue'

export const useSpinner = defineStore('spinner', () => {
  const activeRequests = ref(0)

  const isLoading = computed(() => activeRequests.value > 0)

  const start = () => activeRequests.value++
  const stop = () => (activeRequests.value = Math.max(0, activeRequests.value - 1))

  return { isLoading, start, stop }
})
